/**
 * calendar - controller for the date selector component
 *
 * Copyright (c) 2020 Cameron Beccario
 */

import {pad} from "../util/strings.js";
import * as utc from "../util/utc.js";
import * as d3 from "../lib/d3.js";
import {seq} from "../util/seq.js";
import {model as sharedConfig} from "../framework/sharedState.js";

const state = {
    year: NaN,
    month: NaN,
    day: NaN,
};

function isLocal() {
    return d3.select("#data-date").classed("local");
}

function updateMonthShape() {
    if (isNaN(state.year) || isNaN(state.month)) {
        return;
    }
    const daysInMonth = new Date(state.year, state.month, 0).getDate();
    const firstDay = new Date(state.year, state.month - 1, 1).getDay();

    d3.selectAll("[data-day]").each(function(d, i) {
        const offset = i - firstDay + 1;
        const day = offset < 1 || daysInMonth < offset ? 0 : offset;
        d3.select(this)
            .text(pad(day, 2))
            .attr("data-day", day)
            .classed("cloaked", day === 0);
    });
}

function adjustHighlight(dataAttribute, value) {
    d3.selectAll(`[${dataAttribute}]`).classed("highlighted", false);
    if (!isNaN(value)) {
        d3.selectAll(`[${dataAttribute}="${value}"]`).classed("highlighted", true);
    }
}

function updateHighlights() {
    adjustHighlight("data-year", state.year);
    adjustHighlight("data-month", state.month);
    adjustHighlight("data-day", state.day);
}

function updateDisplay() {
    updateMonthShape();
    updateHighlights();
}

export function update(date = {}) {
    const year = +date.year;
    const month = +date.month;
    const day = +date.day;
    const hour = +date.hour;
    const minute = +date.minute;
    const utcDate = {year, month, day, hour, minute};
    const activeDate = isLocal() ? utc.localParts(utc.date(utcDate)) : utcDate;
    state.year = activeDate.year;
    state.month = activeDate.month;
    state.day = activeDate.day;
    updateDisplay();
}

d3.selectAll("[data-year]").on(seq`click.?`, function() {
    state.year = +d3.select(this).attr("data-year");
    updateDisplay();
});
d3.selectAll("[data-month]").on(seq`click.?`, function() {
    state.month = +d3.select(this).attr("data-month");
    updateDisplay();
});
d3.selectAll("[data-day]").on(seq`click.?`, function() {
    state.day = +d3.select(this).attr("data-day");
    updateDisplay();
});

d3.select("#calendar-apply").on(seq`click.?`, () => {
    d3.select("#calendar-wrapper").classed("hidden", true);
    const utcDate = isLocal() ? utc.parts(new Date(state.year, state.month - 1, state.day)) : state;
    const {year, month, day, hour, minute} = utcDate;
    sharedConfig.save({time_cursor: {year, month, day, hour: hour || 0, minute: minute || 0}});
});
